import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ReturnOrderStatusIcons from "../ReturnOrders/ReturnOrderStatusIcons";

const useStyles = makeStyles({
  cardStatusContainer: {
    opacity: "1",
    display: "flex",
    alignItems: "center",
    padding: "5px",
    borderRadius: "5px",
    textTransform: "capitalize",
    fontSize: "12px",
  },
});
export default function FieldAgentReturnOrderStatusCard({ status }) {
  const styleClass = useStyles();
  const statusData = ReturnOrderStatusIcons[status?.toUpperCase()];
  return (
    <Typography
      variant={"span"}
      sx={{
        color: statusData?.statusColor,
        background: statusData?.statusContainerColor,
      }}
      className={styleClass.cardStatusContainer}
    >
      <img
        src={statusData?.statusIcon}
        alt="order status"
        style={{ marginRight: "8px", height: "20px", width: "20px" }}
      />
      {statusData?.statusMessage || ""}
    </Typography>
  );
}
